module.exports = __webpack_public_path__ + "img/svg/mobile-logo.4806383ddc47e86b9af41af9a982a90f.svg";